import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";

import "./clients-slider.scss";

const clientsData = [
  {
    name: "Genius World Travels",
    logo: "/assets/images/clients/gw-logo.png",
  },
  {
    name: "TCT DMC",
    logo: "/assets/images/clients/tct-logo.png",
  },
];

const ClientsSlider = () => {
  return (
    <section className="clients-section">
  <div className="container">

    <div className="section-header text-center">
      <span className="sub-title">
        Our Trusted Clients
      </span>

      <h2>
        Businesses We Work With
      </h2>

      <p>
        We proudly deliver innovative digital solutions for
        growing travel and enterprise businesses.
      </p>
    </div>

    <div className="row g-4 justify-content-center">

      <div className="col-lg-5 col-md-6">
        <div className="client-box">

          <div className="client-logo">
            <img className="fluid-img"
              src="/assets/images/clients/gw-logo.png"
              alt="Genius World Travels"
            />
          </div>

          <div className="client-content">
            <h4>Genius World Travels</h4>

            <p>
              Leading travel company offering domestic and
              international tour solutions with exceptional
              customer experiences.
            </p>
          </div>

        </div>
      </div>

      <div className="col-lg-5 col-md-6">
        <div className="client-box">

          <div className="client-logo">
            <img className="fluid-img"
              src="/assets/images/clients/tct-logo.png"
              alt="TCT DMC"
            />
          </div>

          <div className="client-content">
            <h4>TCT DMC</h4>

            <p>
              Trusted destination management company providing
              advanced travel operations and tourism services
              across multiple regions.
            </p>
          </div>

        </div>
      </div>

    </div>

  </div>
</section>
  );
};

export default ClientsSlider;